import EmployeeResourcesModal from '../components/EmployeeResourcesModal';
import { getProjectEndDate } from '../services/duration';
import React, { useState, useEffect, Children } from 'react';
import HubSpot from '../components/HubSpot';
import { SaveOutlined, DeliveredProcedureOutlined, LoadingOutlined, CheckCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Row, FloatButton, Drawer, Card, Badge, InputNumber, Select, Modal, Input, Checkbox, message, Spin, Table, Tooltip } from 'antd';
import DealEconomicsSummaries from '../components/DealEconomicsSummaries';
import ParticipantsAndRates from '../components/ParticipantsAndRates';
import CopyDealResourcesModal from '../components/CopyDealResourcesModal';
import NonResourceCosts from '../components/NonResourceCosts';
import { getNonResourceRevenue } from '../services/nonResourceRevenue';
import ResourceAllocationPlan from '../components/ResourceAllocationPlan';
import ProjectRevenue from '../components/ProjectRevenue';
import SummaryTable from '../components/Summary';
import RevenueSummary from '../components/RevenueSummary';
import DealEconomicsSummariesDetails from '../components/DealEconomicsSummariesDetails';
import getMonthlyWorkingHours from '../hooks/MonthlyHoursCalculation';
import { HubSpotData, ResourceAllocationPlanTable, ParticipantsAndRatesTable, NonResourcePricingTable, RevenueData, LineItem, HubspotField, PricingTemplateData } from '../interfaces/interfaces';
import dayjs from 'dayjs';
import { getHubspotDealDetails, getPricingContributors, getPricingVersion, getDealVersionDetails, getPricingCalculatorDetails, getNonResourcePricingDetails, getWorkHours, savePricingDealVersion, getDiscountTargetMarginDD, updatePricingDealVersionName, getPricingDealVersions, getPricingDealVersionCount, getLoggedInUserDetails, getLatestLineItems, updateHubspotLineItems, pricingTemplateDetails, getHubspotUsers, savePricingTemplate, getAllPricingVersions } from '../../services/Apis';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LogoutPopUp from '../../components/LogoutPopUp';
import LineItemCompareTable from '../components/HubSpotLineItem';
import { addOrSubtractDays, addOrSubtractDaysForEndDate, calculateDaysBetweenDates, calculateEndDate, calculateStartDate, changeDiscountAmount, changeDiscountValue, changeTotalAmount, checkStartDateAndDuration, validateInputs } from '../services/services';
import cleanUiResourceRequestList from '../services/cleanUiResourceList';
import HubspotFieldsChangeTable from '../components/HubspotFieldsChangeTable';
import { getTooltip } from '../services/tooltip_services';
import PricingTemplateDetails from '../components/PricingTemplateDetails';
import NoAccessPopup from '../../components/NoAccessPopup';
import CopyPricingTemplateButton from '../components/CopyPricingTemplateButton';

interface EditPricingDetailsProps {
  viewOnly?: boolean
}

const { TextArea } = Input;

const EditPricingDetails: React.FC<EditPricingDetailsProps> = ({ viewOnly: viewOnlyProp = false }) => {
  const [canEditTemplate, setCanEditTemplate] = useState(false);
  const [canCopyTemplate, setCanCopyTemplate] = useState(false);
  const [isLinkedTemplate, setIsLinkedTemplate] = useState(false);
  const viewOnly = viewOnlyProp || !canEditTemplate;

  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // Get search params from the URL
  const [open, setOpen] = useState(false);
  const [dealAllVersionsEconomicsSummaries, setDealAllVersionsEconomicsSummaries] = useState<any[]>([]);
  const [dealAllVersionsHeaderList, setDealAllVersionsHeaderList] = useState<any[]>([]);
  const [versionCount, setVersionCount] = useState(0);
  const [startDate, setStartDate] = useState(dayjs());
  const [oldStartDate, setOldStartDate] = useState(dayjs());
  const [duration, setDuration] = useState(6);
  const [endDate, setEndDate] = useState(getProjectEndDate(dayjs(), duration));

  const dealId = Number(searchParams.get('templateId'));
  const [versionName, setVersionName] = useState(searchParams.get('templateName') || '');
  const [newVersionName, setNewVersionName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [errorArray, setErrorArray] = useState<any[]>([]);
  const [sendEmail, setSendEmail] = useState(false);
  const [sendHubspotLineItems, setSendHubspotLineItems] = useState(false);
  const [showHubspotLineItemsUpdatedMessage, setShowHubspotLineItemsUpdatedMessage] = useState(false);
  const [templateDetails, setTemplateDetails] = useState<any>(null);
  const [hubspotDropdownDetails, setHubspotDropdownDetails] = useState<any>(null);
  // ParticipantsAndRates
  const [ParticipantsAndRatesData, setParticipantsAndRatesData] = useState<ParticipantsAndRatesTable[]>([]);
  const [ParticipantsAndRatesInitialData, setParticipantsAndRatesInitialData] = useState<ParticipantsAndRatesTable[]>([]);
  const [copyResourcesOpen, setCopyResourcesOpen] = useState<false | 'deal' | 'employee'>(false);
  const ResourceImportModal = copyResourcesOpen === 'employee' ? EmployeeResourcesModal : CopyDealResourcesModal;
  const [nonResourceData, setNonResourceData] = useState<NonResourcePricingTable[]>([]);
  const [nonResourceInitialData, setNonResourceInitialData] = useState<NonResourcePricingTable[]>([]);
  const [nonResourcePricingDetails, setNonResourcePricingDetails] = useState<any[]>([]);
  const [dealEconomicsFinalData, setDealEconomicsFinalData] = useState<any[]>([]);
  const [monthlyHours, setMonthlyHours] = useState<any[]>([]);
  const [isDealLocked, setIsDealLocked] = useState<boolean>(false)
  const [lockOde, setlockOde] = useState<boolean>(false)
  const [enabledFeatureList, setEnabledFeatureList] = useState<string[]>([])
  const [isHubspotFieldsChanged, setIsHubspotFieldsChanged] = useState<boolean>(false)
  const [hubspotFieldsChangedArray, setHubspotFieldsChangedArray] = useState<HubspotField[]>([])
  const [lineItems, setLineItems] = useState<LineItem[]>([]);
  const [updatedPricingItems, setUpdatedPricingItems] = useState<LineItem[]>([]);
  const [loader, setLoader] = useState(false);
  const [fatalError, setFatalError] = useState<string | null>(null);
  const [isRedirectToHome, setIsRedirectToHome] = useState(false);
  const [dealTotalAmount, setDealTotalAmount] = useState<number>(0);
  // ResourceAllocationPlan
  const [monthColumns, setMonthColumns] = useState<any[]>(monthlyHours.map(month => month.month));
  const [ResourceAllocationPlanData, setResourceAllocationPlanData] = useState<ResourceAllocationPlanTable[]>([]);
  const [ResourceFinalAllocationPlanData, setResourceFinalAllocationPlanData] = useState<ResourceAllocationPlanTable[]>([]);
  const [revenueData, setRevenueData] = useState<RevenueData[]>([]);
  const [monthlySummaryData, setMonthlySummaryData] = useState<any[]>([]);
  const [monthlySummaryDataAfterDiscount, setMonthlySummaryDataAfterDiscount] = useState<any[]>([]);
  const [servicelineTotalRevenue, setServiceLineTotalRevenue] = useState<any[]>([]);

  const [HubspotDealData, setHubspotDealData] = useState<any>(null);
  const [PricingContributors, setPricingContributors] = useState<any>(null);
  const [pricingCollaborators, setPricingCollaborators] = useState<any>(null);
  const [PricingVersion, setPricingVersion] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [versionId, setVersionId] = useState<number>(1);
  const [pricingCalculatorDetails, setPricingCalculatorDetails] = useState<any>(null);
  const [tokenExpired, setTokenExpired] = useState<boolean>(false);
  const [discountValue, setDiscountValue] = useState<number>(0);
  const [discountAmount, setDiscountAmount] = useState<number>(0);
  const [dealPricingComment, setDealPricingComment] = useState<string>('');
  const [belowTargetMarginReason, setBelowTargetMarginReason] = useState<string>('');
  const [discountRationale, setDiscountRationale] = useState<string>("");
  const [contingencyValue, setcontingencyValue] = useState<number>(0);
  const [dealEconomicsSummaries, setDealEconomicsSummaries] = useState<any>([]);
  const [dealEconomicsGrossNetSummaries, setDealEconomicsGrossNetSummaries] = useState<any>([]);
  const [targetMarginDD, setTargetMarginDD] = useState<any>(null);
  const [discountRationaleDD, setDiscountRationaleDD] = useState<any>(null);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState<boolean>(false);
  const [savePricingLoader, setSavePricingLoader] = useState<boolean>(false);
  const [newVersionNameModalVisible, setNewVersionNameModalVisible] = useState<boolean>(false);
  const [versionNameInputVisible, setVersionNameInputVisible] = useState<boolean>(false);
  const [saveNewPricingVersion, setSaveNewPricingVersion] = useState<boolean>(false);
  const [reloadNavigation, setReloadNavigation] = useState<boolean>(false);
  const [isDealVersionDetailsLoaded, setIsDealVersionDetailsLoaded] = useState<boolean>(false);
  const [distinctServiceLines, setDistinctServiceLines] = useState<string[]>([]);
  const [existingMonthlyAllocation, setExistingMonthlyAllocation] = useState<number>(0);
  const [additionalResourcingInfo, setAdditionalResourcingInfo] = useState<string>("")
  const [minFTEWarning, setminFTEWarning] = useState<boolean>(false);
  const [noAccess, setNoAccess]= useState<boolean>(false)
  const [useOldWorkhours, setUseOldWorkhours] = useState<boolean>(false)
  const [workHours, setWorkHours] = useState<any>(null)
  const [basePricingLoader, setBasePricingLoader] = useState<boolean>(false)

  const handleBasePricingVersionChange = async (newVersionId: number) => {
    if (versionId !== newVersionId) {
      setBasePricingLoader(true);
      setVersionId(newVersionId);
      const pricingCalculatorDetailsData: any = await getPricingCalculatorDetails(null, newVersionId);
      const nonResourceCatalog = await getNonResourcePricingDetails(null, newVersionId);
      setNonResourcePricingDetails(Array.isArray(nonResourceCatalog) ? nonResourceCatalog : []);
      if (pricingCalculatorDetailsData.error) {
        message.error(pricingCalculatorDetailsData.error);
        setBasePricingLoader(false);
        return;
      }
      const resourceData = JSON.parse(JSON.stringify(ParticipantsAndRatesData));
      const distinctServiceLines: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.service_line)));
      const distinctRegions: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.region)));
      const distinctCareerLevels: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.career_level)));
      const distinctFunctions: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.function)));
      const distinctResourceTypes: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.resource_type)));
      const resourceCleanData = cleanUiResourceRequestList(resourceData, {
        resourceTypes: distinctResourceTypes,
        selectRegions: distinctRegions,
        serviceLineCapabilities: distinctServiceLines,
        functions: distinctFunctions,
        selectLevels: distinctCareerLevels
      });
      setPricingCalculatorDetails(pricingCalculatorDetailsData);
      setParticipantsAndRatesInitialData(resourceCleanData.map((item: any) => {
        const lookUpValues = pricingCalculatorDetailsData.filter((data: any) => data.resource_type === item.resourceType && data.region === item.selectRegion && data.service_line === item.serviceLineCapability && data.career_level === item.selectLevel && data.function === item.function)[0];
        const loadedLaborCostHr = lookUpValues?.cost_per_hour ?? item.loadedLaborCostHr;
        const targetClientMargin = lookUpValues?.target_client_margin ? Number((lookUpValues?.target_client_margin * 100).toFixed(2)) : item.targetClientMargin;
        const minFTE = lookUpValues?.min_fte_allocation ?? 0;
        return {
          'key': item.key,
          'oldKey': item.oldKey ?? item.key,
          'resourceType': item.resourceType,
          'selectRegion': item.selectRegion,
          'serviceLineCapability': item.serviceLineCapability,
          'function': item.function,
          'selectLevel': item.selectLevel,
          'loadedLaborCostHr': loadedLaborCostHr,
          'targetClientMargin': targetClientMargin,
          'proposedPriceHr': item.proposedPriceHr,
          'targetPriceHr': Number(((loadedLaborCostHr * 100) / (100 - targetClientMargin)).toFixed(2)),
          'clientMarginProposed': Number((100 - ((100 * loadedLaborCostHr) / (item.proposedPriceHr))).toFixed(2)),
          'varianceTargetMargin': (Number((100 - ((100 * loadedLaborCostHr) / (item.proposedPriceHr))).toFixed(2))) - targetClientMargin,
          'minFTE': minFTE
        }
      }));
      setDistinctServiceLines([...distinctServiceLines, "Contingency"]);
      if (useOldWorkhours) {
        await fetchAndSetWorkHours(newVersionId);
      }
      setBasePricingLoader(false);
    }
  };

  const fetchAndSetWorkHours = async (basePriceVersionId: number) => {
    const workingHours = await getWorkHours(null, basePriceVersionId);
    if (!workingHours.error) {
      setWorkHours(workingHours);
      const monthlyHours = getMonthlyWorkingHours(startDate.format('YYYY-MM-DD'), duration, workingHours, existingMonthlyAllocation);
      setMonthlyHours(monthlyHours);
      setMonthColumns(monthlyHours.map((month: any) => month.month));
      return true;
    } else {
      message.error('Failed to fetch work hours: ' + workingHours.error);
      return false;
    }
  };

  const handleUseOldWorkhoursChange = async (value: boolean) => {
    setUseOldWorkhours(value);
    if (value) {
      const success = await fetchAndSetWorkHours(versionId);
      if (!success) {
        setUseOldWorkhours(false);
      }
    }
  };

  const handleTemplateDetailsChange = (data: any) => {
    if(data['Engagement Type'] === "Fixed Fee" && HubspotDealData['Engagement Type'] !== 'Fixed Fee') {
      setcontingencyValue(20);
    }else if(data['Engagement Type'] !== "Fixed Fee") {
      setcontingencyValue(0);
    }
    setTemplateDetails(data);
    setHubspotDealData(data);
    setDuration(data['Duration']);
    setOldStartDate(startDate);
    setStartDate(dayjs(data['Expected Start Date'] + "T00:00:00"));
    setEndDate(getProjectEndDate(data['Expected Start Date'] + "T00:00:00", data['Duration']));
    const monthlyHours = getMonthlyWorkingHours(data['Expected Start Date'], data['Duration'], useOldWorkhours && workHours ? workHours : [], existingMonthlyAllocation);
    setMonthlyHours(monthlyHours);
    setMonthColumns(monthlyHours.map(month => month.month));
  };

  const handleParticipantsAndRatesCallback = (data: ParticipantsAndRatesTable[]) => {
    if (data.length === 0) {
      setRevenueData([])
      setMonthlySummaryData([])
      setMonthlySummaryDataAfterDiscount([])
      setServiceLineTotalRevenue([])
      setResourceFinalAllocationPlanData([])
    }
    setParticipantsAndRatesData(data);
    const idDataComplete = Object.values(data).every(value => value !== null && value !== undefined);

  };

  const handledealEconomicsFinalData = (data: any[]) => {
    if (data.length > 0) {
      // setBelowTargetMarginReason(data[0]?.belowTargetMarginReason);
      // setDealPricingComment(data[0]?.dealPricingComment);
      setDealEconomicsFinalData(data ?? []);
    }
  };

  const calculateNetValue = (revenue: number, contingency: number, discount: number) => {
    const netRevenue = (revenue * (1 + (contingency / 100))) * (1 - (discount / 100))
    return netRevenue
  }

  const calculateWorkingDays = (startDate: any, endDate: any) => {
    let workingDays = 0;

    // Iterate through each day of the month
    for (let day = dayjs(startDate); day.isBefore(dayjs(endDate)) || day.isSame(endDate, 'day'); day = day.add(1, 'day')) {
      const weekDay = day.day(); // dayjs returns 0-6 (Sunday-Saturday)
      if (weekDay !== 0 && weekDay !== 6) {
        workingDays++;
      }
    }

    return workingDays;
  }

  const handleResourceAllocationCallback = (data: ResourceAllocationPlanTable[]) => {
    setResourceFinalAllocationPlanData(data);
    const revenueDataMapper: any = []
    const serviceLineRevenue: any = []
    const serviceLineRevenueObject: any = {}
    const nonResourceRevenue = getNonResourceRevenue(nonResourceData, monthlyHours.map(month => month.month), ParticipantsAndRatesData.length);
    if ((ParticipantsAndRatesData.length === 0 || data.length === 0) && nonResourceRevenue.length === 0) {
      setRevenueData([])
      setMonthlySummaryData([])
      setMonthlySummaryDataAfterDiscount([])
      setServiceLineTotalRevenue([])
    } else {
      if(data.length > 0 && data.length === ParticipantsAndRatesData.length && Object.keys(data[0]?.months).length === monthlyHours?.length) {
      ParticipantsAndRatesData.forEach((element, index) => {
        const billableHours: any = { key: `${index + 1}-1`, role: "Billable Hours" }
        const monthlyRevenue: any = { key: `${index + 1}-2`, role: "Revenue $" }
        const costRevenue: any = { key: `${index + 1}-3`, role: "Cost $" }
        const clientMarginRevenue: any = { key: `${index + 1}-4`, role: "Client Margin $" }
        const targetRevenue: any = { key: `${index + 1}-5`, role: "Target Revenue $" }
        const targetMarginRevenue: any = { key: `${index + 1}-6`, role: "Target Margin $" }

        let totalBillableHours = 0
        let totalMonthlyRevenue = 0
        let totalConstRevenue = 0
        let totalClientMarginRevenue = 0
        let totalTargetRevenue = 0
        let totalTargetMarginRevenue = 0

        monthlyHours.map((month: any, i: any) => {
          const currentMonth = month.month.split('-')[0]
          const currentYear = month.month.split('-')[1]
          let currentMonthBillableCoefficient = 1

          // Map month abbreviations to month indices (0-based)
          const monthIndex = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"].indexOf(currentMonth);

          // Convert the two-digit year to a four-digit year
          const fullYear = parseInt(`20${currentYear}`, 10);

          // Create a new dayjs date for the 1st of the given month and year
          const dateToCheck = dayjs(new Date(fullYear, monthIndex, 1));
          let workingDays = calculateWorkingDays(dayjs(dateToCheck).startOf("month"), dayjs(dateToCheck).endOf("month"));

          // Calculate billable coefficient and working days for partial months
          if (currentYear === data[index].startDate.format('YY').toUpperCase() &&
            currentYear === data[index].endDate.format('YY').toUpperCase() &&
            currentMonth === data[index].startDate.format('MMM').toUpperCase() &&
            currentMonth === data[index].endDate.format('MMM').toUpperCase()) {
            currentMonthBillableCoefficient = calculateWorkingDays(data[index].startDate, data[index].endDate) / calculateWorkingDays(data[index].startDate.startOf("month"), data[index].startDate.endOf("month"));
            workingDays = calculateWorkingDays(data[index].startDate, data[index].endDate);
          } else if (currentYear === data[index].startDate.format('YY').toUpperCase() && currentMonth === data[index].startDate.format('MMM').toUpperCase()) {
            currentMonthBillableCoefficient = (calculateWorkingDays(data[index].startDate, data[index].startDate.endOf("month"))) / calculateWorkingDays(data[index].startDate.startOf("month"), data[index].startDate.endOf("month"));
            workingDays = calculateWorkingDays(data[index].startDate, data[index].startDate.endOf("month"));
          } else if (currentYear === data[index].endDate.format('YY').toUpperCase() && currentMonth === data[index].endDate.format('MMM').toUpperCase()) {
            currentMonthBillableCoefficient = (calculateWorkingDays(data[index].endDate.startOf("month"), data[index].endDate)) / calculateWorkingDays(data[index].endDate.startOf("month"), data[index].endDate.endOf("month"));
            workingDays = calculateWorkingDays(data[index].endDate.startOf("month"), data[index].endDate);
          }

          if (useOldWorkhours && month.hours.length > 0) {
            billableHours[`month${i}`] = Math.round((month.hours.filter((hourData: any) => hourData.region == element.selectRegion && hourData.resourceType == element.resourceType)[0]?.hours * (data[index].months[`month${i}`] / 100) * currentMonthBillableCoefficient))
          } else {
            billableHours[`month${i}`] = Math.round((8 * workingDays * (data[index].months[`month${i}`] / 100)));
          }
          totalBillableHours += billableHours[`month${i}`]
          monthlyRevenue[`month${i}`] = Math.round((billableHours[`month${i}`] * element.proposedPriceHr))
          totalMonthlyRevenue += monthlyRevenue[`month${i}`]
          targetRevenue[`month${i}`] = Math.round((billableHours[`month${i}`] * element.targetPriceHr))
          totalTargetRevenue += targetRevenue[`month${i}`]
          costRevenue[`month${i}`] = Math.round((billableHours[`month${i}`] * element.loadedLaborCostHr))
          totalConstRevenue += costRevenue[`month${i}`]
          clientMarginRevenue[`month${i}`] = Math.round((monthlyRevenue[`month${i}`] - costRevenue[`month${i}`]))
          totalClientMarginRevenue += clientMarginRevenue[`month${i}`]
          targetMarginRevenue[`month${i}`] = Math.round((targetRevenue[`month${i}`] - costRevenue[`month${i}`]))
          totalTargetMarginRevenue += targetMarginRevenue[`month${i}`]
        })

        billableHours.total = Math.round(totalBillableHours)
        monthlyRevenue.total = Math.round(totalMonthlyRevenue)
        costRevenue.total = Math.round(totalConstRevenue)
        clientMarginRevenue.total = Math.round(totalClientMarginRevenue)
        targetRevenue.total = Math.round(totalTargetRevenue)
        targetMarginRevenue.total = Math.round(totalTargetMarginRevenue)

        if (!serviceLineRevenueObject[element.serviceLineCapability]) {//if the service line is not present in the object
          // const contingencyAmount = Number((totalMonthlyRevenue * (contingencyValue / 100)).toFixed(2))
          const contingencyAmount = 0
          const discountAmount = (totalMonthlyRevenue + contingencyAmount) * (discountValue / 100)
          serviceLineRevenueObject[element.serviceLineCapability] = { key: `${index + 1}`, service: element.serviceLineCapability, core: totalMonthlyRevenue, contingency: contingencyAmount, discount: discountAmount, net: calculateNetValue(totalMonthlyRevenue, 0, discountValue) }
        } else {//if the service line is present in the object
          // const contingencyAmount = Number((totalMonthlyRevenue * (contingencyValue / 100)).toFixed(2))
          const contingencyAmount = 0
          const discountAmount = (totalMonthlyRevenue + contingencyAmount) * (discountValue / 100)
          serviceLineRevenueObject[element.serviceLineCapability].contingency = ((serviceLineRevenueObject[element.serviceLineCapability].contingency + contingencyAmount))
          serviceLineRevenueObject[element.serviceLineCapability].discount = ((serviceLineRevenueObject[element.serviceLineCapability].discount + discountAmount))
          serviceLineRevenueObject[element.serviceLineCapability].core = ((serviceLineRevenueObject[element.serviceLineCapability].core + totalMonthlyRevenue))
          serviceLineRevenueObject[element.serviceLineCapability].net = ((serviceLineRevenueObject[element.serviceLineCapability].net + calculateNetValue(totalMonthlyRevenue, 0, discountValue)))
        }
        const objectData: RevenueData = {
          key: `month${index + 1}`,
          role: `${element.resourceType} - ${element.selectRegion} - ${element.serviceLineCapability} - ${element.selectLevel}`,
          total: Math.round(totalMonthlyRevenue),
          children: [billableHours, monthlyRevenue, targetRevenue, costRevenue, clientMarginRevenue, targetMarginRevenue]
        }
        Object.keys(monthlyRevenue).forEach((key: any) => {
          if (key.startsWith('month'))
            objectData[key] = monthlyRevenue[key]
        })
        revenueDataMapper.push(objectData)
      });
      }
      revenueDataMapper.push(...nonResourceRevenue);
      nonResourceRevenue.forEach(row => {
        const service = row.role.split(' - ')[2];
        const totals = serviceLineRevenueObject[service] ?? { key: service, service, core: 0, contingency: 0, discount: 0, net: 0 };
        totals.core += row.total;
        totals.discount += row.total * discountValue / 100;
        totals.net += calculateNetValue(row.total, 0, discountValue);
        serviceLineRevenueObject[service] = totals;
      });
      Object.keys(serviceLineRevenueObject).forEach((key) => {
        serviceLineRevenueObject[key].core = Math.round(serviceLineRevenueObject[key].core)
        serviceLineRevenueObject[key].contingency = Math.round(serviceLineRevenueObject[key].contingency)
        serviceLineRevenueObject[key].discount = Math.round(serviceLineRevenueObject[key].discount)
        serviceLineRevenueObject[key].net = Math.round(serviceLineRevenueObject[key].net)
        serviceLineRevenue.push(serviceLineRevenueObject[key])
      })
      setRevenueData(revenueDataMapper)
      const monthlSum: any = sumByCategoryAndMonth(revenueDataMapper)
      const monthlSumAfterDiscount: any = calculateSumAfterDiscountAndContingency(JSON.parse(JSON.stringify(monthlSum)))

      // --- Begin Adjustment Logic for monthlSumAfterDiscount ---
      // Only declare totalRevenueObj once
      const totalRevenueObj = monthlSumAfterDiscount.find((item: any) => item.summary === "Total Revenue");
      if (totalRevenueObj && Array.isArray(totalRevenueObj.children)) {
        let serviceLines = totalRevenueObj.children;
        const sumServiceLines = serviceLines.reduce((acc: number, sl: any) => acc + (sl.total || 0), 0);
        const diff = (totalRevenueObj.total || 0) - sumServiceLines;
        // skip contingency and sort by total descending
        serviceLines = serviceLines.filter((item: any) => item.summary !== "Contingency").sort((a: any, b: any) => b.total - a.total);
        const n = serviceLines.length;
        const sign = Math.sign(diff);
        const absDiff = Math.abs(diff);
        for (let i = 0; i < absDiff; i++) {
          serviceLines[i % n].total += sign;
        }
      }
      // --- End Adjustment Logic for monthlSumAfterDiscount ---

      // Always update serviceLineRevenue with Contingency from adjusted monthlSumAfterDiscount
      const totalRevenue = monthlSumAfterDiscount.find((item: any) => item.summary === "Total Revenue");
      const contingencyTotalRevenue = totalRevenue?.children.find((child: any) => child.summary === "Contingency")?.total;
      serviceLineRevenue.push({ key: 'contingency', service: 'Contingency', core: contingencyTotalRevenue, contingency: 0, discount: 0, net: contingencyTotalRevenue });
      // update serviceLineRevenue net totalRevenueObj children net based summary
      totalRevenueObj?.children.forEach((child: any) => {
        const serviceLine = serviceLineRevenue.find((item: any) => item.service === child.summary);
        if (serviceLine) {
          serviceLine.net = child.total;
        }
      });
      setMonthlySummaryData(monthlSum)
      setMonthlySummaryDataAfterDiscount(monthlSumAfterDiscount)
      setServiceLineTotalRevenue(serviceLineRevenue)
    }

  };

  // Calculate Total Monthly Summary Before Discount and Contingency
  const sumByCategoryAndMonth = (data: any[]) => {
    const summary: Record<string, Record<string, any>> = {};
    const serviceLineTotalRevenueColumns: any = {}


    // Initialize the summary object
    const categories = ["Billable Hours", "Revenue $", "Target Revenue $", "Cost $", "Client Margin $", "Target Margin $"];
    categories.forEach((category) => {
      summary[category] = {}
      serviceLineTotalRevenueColumns[category] = {}
    });

    // Summing values for each category and month
    data.forEach((item) => {
      item.children.forEach((child: any) => {
        const category = child.role;
        if (!serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]])
          serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]] = {};
        Object.keys(child).forEach((key) => {
          if (key.startsWith("month")) {
            summary[category][key] = Number((Number((summary[category][key] || 0).toFixed(2)) + Number(child[key].toFixed(2))).toFixed(2));
            serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]][key] = Number((Number((serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]][key] || 0).toFixed(2)) + Number(child[key].toFixed(2))).toFixed(2));
            serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]]['total'] = Number((Number((serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]]['total'] || 0).toFixed(2)) + Number(child[key].toFixed(2))).toFixed(2));
          }
        });
      });
    });

    // Calculate client margin % for each month for each SL
    serviceLineTotalRevenueColumns["Client Margin %"] = {}
    Object.keys(serviceLineTotalRevenueColumns['Revenue $']).forEach((serviceLine) => {
      serviceLineTotalRevenueColumns["Client Margin %"][serviceLine] = {}
      Object.keys(serviceLineTotalRevenueColumns['Revenue $'][serviceLine]).forEach((month) => {
        const revenue = serviceLineTotalRevenueColumns['Revenue $'][serviceLine][month];
        const cost = serviceLineTotalRevenueColumns['Cost $'][serviceLine][month];
        const marginPercentage = revenue ? 100 - (cost * 100) / revenue : 0;
        serviceLineTotalRevenueColumns["Client Margin %"][serviceLine][month] = `${marginPercentage.toFixed(1)}%`;
      })
    });

    // Calculate target margin % for each month for each SL
    serviceLineTotalRevenueColumns['Target Margin %'] = {};
    Object.keys(serviceLineTotalRevenueColumns['Target Revenue $']).forEach((serviceLine) => {
      serviceLineTotalRevenueColumns["Target Margin %"][serviceLine] = {}
      Object.keys(serviceLineTotalRevenueColumns['Target Revenue $'][serviceLine]).forEach((month) => {
        const revenue = serviceLineTotalRevenueColumns['Target Revenue $'][serviceLine][month];
        const cost = serviceLineTotalRevenueColumns['Cost $'][serviceLine][month];
        const marginPercentage = revenue ? 100 - (cost * 100) / revenue : 0;
        serviceLineTotalRevenueColumns["Target Margin %"][serviceLine][month] = `${marginPercentage.toFixed(1)}%`;
      });
    });


    const results = [
      {
        key: '1',
        summary: 'Total Revenue',
        ...Object.fromEntries(
          Object.entries(summary['Revenue $']).map(([k, v]) => [k, v])
        ),
        total: Math.round(Object.values(summary['Revenue $']).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns['Revenue $']).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns['Revenue $'][key]).map(([k, v]) => [k, v])
            ),
          }
        })
      },
      {
        key: '2',
        summary: 'Total Target Revenue',
        ...Object.fromEntries(
          Object.entries(summary['Target Revenue $']).map(([k, v]) => [k, v])
        ),
        total: Math.round(Object.values(summary['Target Revenue $']).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns['Target Revenue $']).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns['Target Revenue $'][key]).map(([k, v]) => [k, v])
            )
          }
        })
      },

      {
        key: '3',
        summary: 'Total Billable Hours',
        ...summary['Billable Hours'],
        total: Math.round(Object.values(summary['Billable Hours']).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns['Billable Hours']).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns['Billable Hours'][key]).map(([k, v]) => [k, v + ' hr'])
            )
          }
        })
      },
      {
        key: '4',
        summary: 'Total Cost',
        ...Object.fromEntries(
          Object.entries(summary['Cost $']).map(([k, v]) => [k, v])
        ),
        total: Math.round(Object.values(summary['Cost $']).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns['Cost $']).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns['Cost $'][key]).map(([k, v]) => [k, v])
            )
          }
        })
      },
      {
        key: '5',
        summary: 'Total Client Margin $',
        ...Object.fromEntries(
          Object.entries(summary['Client Margin $']).map(([k, v]) => [k, v])
        ),
        total: Math.round(Object.values(summary['Client Margin $']).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns['Client Margin $']).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns['Client Margin $'][key]).map(([k, v]) => [k, v])
            )
          }
        })
      },
      {
        key: '6',
        summary: 'Total Target Margin $',
        ...Object.fromEntries(
          Object.entries(summary['Target Margin $']).map(([k, v]) => [k, v])
        ),
        total: Math.round(Object.values(summary['Target Margin $']).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns['Target Margin $']).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns['Target Margin $'][key]).map(([k, v]) => [k, v])
            )
          }
        })
      }
    ];

    // Calculate client margin % for each month
    const clientMarginPercentage: any = {};
    Object.keys(summary['Revenue $']).forEach((month) => {
      const revenue = summary['Revenue $'][month];
      const cost = summary['Cost $'][month];
      const marginPercentage = revenue ? 100 - (cost * 100) / revenue : 0;
      clientMarginPercentage[month] = `${marginPercentage.toFixed(1)}%`;
    });

    // Add client margin % to the results
    results.push({
      key: '7',
      summary: 'Client Margin %',
      ...clientMarginPercentage,
      total: `${Object.values(summary['Revenue $']).reduce((acc, v) => acc + v, 0) === 0 ? 0 : (
        100 -
        (Object.values(summary['Cost $']).reduce((acc, v) => acc + v, 0) * 100) /
        Object.values(summary['Revenue $']).reduce((acc, v) => acc + v, 0)
      ).toFixed(1)}%`,
      children: Object.entries(serviceLineTotalRevenueColumns['Client Margin %']).map(([key, value]) => {
        return {
          summary: key,
          ...Object.fromEntries(
            Object.entries(serviceLineTotalRevenueColumns['Client Margin %'][key]).map(([k, v]) => [k, v])
          )
        }
      })
    });

    // Calculate target margin % for each month
    const targetMarginPercentage: any = {};
    Object.keys(summary['Target Revenue $']).forEach((month) => {
      const revenue = summary['Target Revenue $'][month];
      const cost = summary['Cost $'][month];
      const marginPercentage = revenue ? 100 - (cost * 100) / revenue : 0;
      targetMarginPercentage[month] = `${marginPercentage.toFixed(1)}%`;
    });

    // Add target margin % to the results
    results.push({
      key: '8',
      summary: 'Target Margin %',
      ...targetMarginPercentage,
      total: `${Object.values(summary['Target Revenue $']).reduce((acc, v) => acc + v, 0) === 0 ? 0 : (
        100 -
        (Object.values(summary['Cost $']).reduce((acc, v) => acc + v, 0) * 100) /
        Object.values(summary['Target Revenue $']).reduce((acc, v) => acc + v, 0)
      ).toFixed(1)}%`,
      children: Object.entries(serviceLineTotalRevenueColumns['Target Margin %']).map(([key, value]) => {
        return {
          summary: key,
          ...Object.fromEntries(
            Object.entries(serviceLineTotalRevenueColumns['Target Margin %'][key]).map(([k, v]) => [k, v])
          )
        }
      })
    });

    return results;
  };

  // Calculate Total Monthly Summary After Discount and Contingency
  const calculateSumAfterDiscountAndContingency = (data: any[]) => {
    let summaryAfterDiscountAndContingency = data.map((item) => {
      // Loop through each month and total keys
      const updatedItem = { ...item };
      // Gather all unique month keys dynamically
      const monthKeys = new Set<string>();
      Object.keys(item.children).forEach(key => {
        if (key.startsWith("month")) {
          monthKeys.add(key);
        }
      });
      // Create the new "Contingency" entry with all month values set to 0
      const newEntry: any = { summary: "Contingency", total: 0 };
      monthKeys.forEach(key => {
        newEntry[key] = 0;
      });
      item.children.push(newEntry);

      // Update only numeric values (ignore percentage strings)
      if (!['Total Target Revenue', 'Total Target Margin $', 'Target Margin %'].includes(item['summary'])) {
        for (const key in item) {
          if (key.startsWith("month") || key === "total") {
            if (typeof item[key] === "number") {
              // Add contingency and subtract discount
              if (item['summary'] !== 'Total Cost') {
                if (item['summary'] === 'Total Billable Hours') {
                  updatedItem[key] = Math.round(item[key] * (1 + (contingencyValue / 100))) + ' hr';
                } else {
                  updatedItem[key] = Math.round(Math.round(item[key] * (1 + (contingencyValue / 100))) * (1 - (discountValue / 100)));
                }
              }
              else
                updatedItem[key] = Math.round(item[key] * (1 + (contingencyValue / 100)));
            }

            item.children.forEach((child: any) => {
              if (child.summary !== "Contingency") {
                if (typeof child[key] === "number") {
                  // Add contingency and subtract discount
                  if (item['summary'] !== 'Total Cost' && item['summary'] !== 'Total Billable Hours')
                    child[key] = Math.round(child[key] * (1 - (discountValue / 100)));
                }
              } else {
                if (item['summary'] !== 'Total Cost') {
                  if (item['summary'] === 'Total Billable Hours') {
                    child[key] = Math.round(item[key] * (contingencyValue / 100)) + ' hr';
                  } else {
                    child[key] = Math.round(item[key] * ((100 - discountValue) / 100) * (contingencyValue / 100));
                  }
                }
                else
                  child[key] = Math.round(item[key] * (contingencyValue / 100));
              }
            });

          }
        }
      }
      return updatedItem;
    });

    // Function to calculate the client margin dollar amount
    const calculateClientMarginDollar = (revenue: number, cost: number): number => {
      return revenue - cost;
    }

    // Function to calculate the client margin percentage
    const calculateClientMargin = (revenue: number, cost: number): string => {
      return revenue !== 0 ? revenue - cost !== 0 ? ((revenue - cost) / revenue * 100).toFixed(1) + '%' : '0.0%' : '0.0%';
    };

    // Find the total revenue, total cost, and client margin objects from the data array
    const totalRevenue = summaryAfterDiscountAndContingency.find(item => item.summary === "Total Revenue");
    const totalCost = summaryAfterDiscountAndContingency.find(item => item.summary === "Total Cost");
    const clientMarginDollar = summaryAfterDiscountAndContingency.find(item => item.summary === "Total Client Margin $");
    const clientMargin = summaryAfterDiscountAndContingency.find(item => item.summary === "Client Margin %");

    if (totalRevenue && totalCost && clientMarginDollar) {
      // Function to calculate margins for each key in the objects
      const calculateMarginsDollar = (revenueObj: any, costObj: any, marginObj: any) => {
        for (const key in revenueObj) {
          // Skip the keys that are not relevant for margin calculation
          if (key !== 'summary' && key !== 'key' && key !== 'children') {
            marginObj[key] = calculateClientMarginDollar(revenueObj[key], costObj[key]);
          }
        }
      };

      // Calculate margins for the total revenue and total cost
      calculateMarginsDollar(totalRevenue, totalCost, clientMarginDollar);

      // Calculate margins for each child, ignoring "Contingency"
      clientMarginDollar.children?.forEach((child: any) => {
        if (child.summary !== "Contingency") {
          const revenueChild = totalRevenue.children?.find((c: any) => c.summary === child.summary);
          const costChild = totalCost.children?.find((c: any) => c.summary === child.summary);
          if (revenueChild && costChild) {
            calculateMarginsDollar(revenueChild, costChild, child);
          }
        }
      });
    }

    if (totalRevenue && totalCost && clientMargin) {
      // Function to calculate margins for each key in the objects
      const calculateMargins = (revenueObj: any, costObj: any, marginObj: any) => {
        for (const key in revenueObj) {
          // Skip the keys that are not relevant for margin calculation
          if (key !== 'summary' && key !== 'key' && key !== 'children') {
            marginObj[key] = calculateClientMargin(revenueObj[key], costObj[key]);
          }
        }
      };

      // Calculate margins for the total revenue and total cost
      calculateMargins(totalRevenue, totalCost, clientMargin);

      // Calculate margins for each child, ignoring "Contingency"
      clientMargin.children?.forEach((child: any) => {
        if (child.summary !== "Contingency") {
          const revenueChild = totalRevenue.children?.find((c: any) => c.summary === child.summary);
          const costChild = totalCost.children?.find((c: any) => c.summary === child.summary);
          if (revenueChild && costChild) {
            calculateMargins(revenueChild, costChild, child);
          }
        }
      });
    }

    return summaryAfterDiscountAndContingency;
  }

  const savePricingVersionDetails = async () => {
    setSavePricingLoader(true);
    if (discountValue != 0 || ParticipantsAndRatesData.length == 0 || ResourceFinalAllocationPlanData.length == 0) {
      // if (ParticipantsAndRatesData.length == 0 || ResourceFinalAllocationPlanData.length == 0) {
      //   setSavePricingLoader(false);
      //   window.scrollTo({
      //     top: 0, // Scroll to the top
      //     behavior: 'smooth' // Smooth scrolling
      //   });
      //   return setError('Please add participants and rates');
      // }
      if (discountValue !== 0 && !discountRationale) {
        setSavePricingLoader(false);
        window.scrollTo({
          top: 0, // Scroll to the top
          behavior: 'smooth' // Smooth scrolling
        });
        return setError('Please provide a discount rationale');
      }
    }
    if (viewOnly) {
      setSavePricingLoader(false);
      return;
    }
    const saveResponse = await savePricingTemplate(dealId, discountValue, discountRationale, contingencyValue, templateDetails, ParticipantsAndRatesData, ResourceFinalAllocationPlanData, dealEconomicsFinalData, nonResourceData)
    if (saveResponse.error_status === 409) {
      setCanEditTemplate(false);
      setIsLinkedTemplate(true);
    }
    if (saveResponse.error_status === 401) {
      setSavePricingLoader(false);
      setTokenExpired(true);
    } else {
      if (saveResponse.error) {
        setSavePricingLoader(false);
        console.error('Error Response Data:', saveResponse.error);
        console.error('Error Response Status:', saveResponse.error_status);
        setError(saveResponse.error);
      } else {
        // if (sendHubspotLineItems) {
        //   let updateLineItems = await updateHubspotLineItems(dealId, updatedPricingItems);
        //   if (updateLineItems.error_status === 401) {
        //     setSavePricingLoader(false);
        //     setTokenExpired(true);
        //   } else {
        //     if (updateLineItems.error) {
        //       setSavePricingLoader(false);
        //       console.error('Error Response Data:', updateLineItems.error);
        //       console.error('Error Response Status:', updateLineItems.error_status);
        //       setError(updateLineItems.error);
        //     } else {
        //       setSavePricingLoader(false);
        //       setIsSuccessModalVisible(true);
        //     }
        //   }
        // } else {
        setSavePricingLoader(false);
        setIsSuccessModalVisible(true);
        // }
      }
    }
  }

  const handleAmountChange = (name: string, amount: number) => {
    setUpdatedPricingItems((prevState: any) => {
      const serviceLineExists = prevState.findIndex((item: any) => item.name === name);
      if (serviceLineExists !== -1) {
        const updatedServiceLineItems = [...prevState];
        updatedServiceLineItems[serviceLineExists].amount = amount;
        return updatedServiceLineItems;
      } else {
        return [...prevState, { name, amount }];
      }
    });
  }

  const checkValidations = () => {
    const validateInputsObject: any = { "Deal Id": dealId, "Version Name": versionName, "Resource Data": ParticipantsAndRatesData, "Resource Allocation Data": ResourceFinalAllocationPlanData, "Deal Economics Data": dealEconomicsFinalData }
    if (discountValue != 0) {
      validateInputsObject["Discount Rationale"] = discountRationale
    }
    if (dealEconomicsFinalData.length > 0 && dealEconomicsFinalData[0]['varianceToTargetMargin']?.replace('%', '') < 0) {
      validateInputsObject["Below Target Margin Reason"] = dealEconomicsFinalData[0]['belowTargetMarginReason']
    }
    const validationErrors = validateInputs(validateInputsObject);
    if (validationErrors.length > 0) {
      setError(validationErrors.map(error => `${error.key}:${error.error}`).join(","))
      window.scrollTo({
        top: 0, // Scroll to the top
        behavior: "smooth", // Smooth scrolling
      });
    } else {
      setError("")
      setNewVersionNameModalVisible(true);
    }
  }

  // State for HubSpot deal details
// Fetch HubSpot deal details when component mounts
useEffect(() => {
  if (dealId !== null && dealId !== undefined && dealId > 0) {
    const fetchDealDetails = async () => {
      const featureListPromise: any = getLoggedInUserDetails();
      const pricingContributorsPromise: any = getHubspotUsers();
      const dealVersionDetailsPromise: any = pricingTemplateDetails(dealId);
      const pricingVersionPromise: any = getAllPricingVersions()
      const discountTargetMarginDDPromise = getDiscountTargetMarginDD();

      const featureList: any = await featureListPromise;
      const pricingContributors: any = await pricingContributorsPromise;
      const dealVersionDetails: any = await dealVersionDetailsPromise;
      const basePriceVersion = dealVersionDetails.base_price_version_id ?? null;
      const nonResourceCatalog = await getNonResourcePricingDetails(null, basePriceVersion);
      setNonResourcePricingDetails(Array.isArray(nonResourceCatalog) ? nonResourceCatalog : []);
      setVersionId(basePriceVersion);
      const pricingCalculatorDetailsDataPromise: any = getPricingCalculatorDetails(null, basePriceVersion);
      const pricingCalculatorDetailsData: any = await pricingCalculatorDetailsDataPromise;
      const discountTargetMarginDD = await discountTargetMarginDDPromise;
      const pricingVersion: any = await pricingVersionPromise;

      if (!featureList.error && !pricingContributors.error && !pricingVersion.error && !dealVersionDetails.error && !pricingCalculatorDetailsData.error && !discountTargetMarginDD.error) {
        const fatalError = checkStartDateAndDuration(dealVersionDetails.project_start_date, dealVersionDetails.duration_in_months)
        if (fatalError !== '') {
          setFatalError(fatalError)
          setIsRedirectToHome(true)
        } 
        const totalNoOfMonths = dealVersionDetails?.resource_allocation_plan.length > 0 ? Object.keys(dealVersionDetails.resource_allocation_plan[0].monthly_wise_allocation).length - 1: 0;
        const monthlyHours = getMonthlyWorkingHours(dealVersionDetails.project_start_date, dealVersionDetails.duration_in_months, [], totalNoOfMonths);
        setExistingMonthlyAllocation(totalNoOfMonths);
        setEnabledFeatureList(featureList.data.features);
        setCanEditTemplate(dealVersionDetails.can_edit === true);
        setCanCopyTemplate(dealVersionDetails.can_copy === true);
        setIsLinkedTemplate(dealVersionDetails.associated_deal_count > 0);
        setIsDealVersionDetailsLoaded(true);
        setMonthlyHours(monthlyHours);
        setIsDealLocked(dealVersionDetails['is_deal_locked'] ? dealVersionDetails['is_deal_locked'] : false)

        if (!dealVersionDetails['duration_in_months']) {
          setErrorArray([...errorArray, { 'Duration': 'Duration is not valid' }])
        }
        
        const dealDetails: PricingTemplateData = {
          'Template Name': dealVersionDetails.template_name,
          'Template Description': dealVersionDetails.template_description,
          'Engagement Type': dealVersionDetails.engagement_type,
          'Expected Start Date': dealVersionDetails.project_start_date ? dayjs(dealVersionDetails.project_start_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")) : dealVersionDetails.project_start_date, // Format as needed
          'Duration': `${dealVersionDetails.duration_in_months}`,
          'Pricing Contributors': dealVersionDetails?.pricing_contributors,
          'Base Price Version ID': dealVersionDetails?.base_price_version_id ?? 2,
          'Base Price Version Name': pricingVersion?.filter((bv: { [x: string]: any; })=> bv?.['id'] == dealVersionDetails?.base_price_version_id)[0]?.name || '',
          'Use Old Workhours': false
        };

        setStartDate(dayjs(dealVersionDetails.project_start_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")));
        setEndDate(getProjectEndDate(dealVersionDetails.project_start_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, ""), dealVersionDetails.duration_in_months));
        setDuration(dealVersionDetails.duration_in_months);
        setNonResourceInitialData((dealVersionDetails.non_resource_data ?? []).map((item: any, index: number) => ({
          key: index + 1, oldKey: index + 1,
          selectRegion: item.region, serviceLineCapability: item.service_line, function: item.function,
          monthlyCost: item.monthly_cost, targetClientMargin: item.target_client_margin,
          targetPricePerMonth: Number((item.monthly_cost * 100 / (100 - item.target_client_margin)).toFixed(2)),
          startDate: dayjs(item.start_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, '')),
          endDate: dayjs(item.end_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, '')),
        })));
        // Map API data to UI format first, then clean against the current base pricing version's valid values
        const rawParticipantsData = dealVersionDetails.participants_rate_data.map((item: any) => ({
          'key': item.key,
          'oldKey': item.key,
          'resourceType': item.resource_type,
          'selectRegion': item.region,
          'serviceLineCapability': item.service_line,
          'function': item.function,
          'selectLevel': item.career_level,
          'loadedLaborCostHr': item.cost_per_hour,
          'targetClientMargin': item.target_client_margin,
          'proposedPriceHr': item.proposed_price_per_hour,
          'targetPriceHr': (item.cost_per_hour * 100) / (100 - item.target_client_margin),
          'clientMarginProposed': Number((100 - ((100 * item.cost_per_hour) / (item.proposed_price_per_hour))).toFixed(2)),
          'varianceTargetMargin': (Number((100 - ((100 * item.cost_per_hour) / (item.proposed_price_per_hour))).toFixed(2))) - item.target_client_margin,
          'minFTE': 1,
        }));

        // Extract valid dropdown values from the current base pricing version
        const initDistinctRegions: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.region)));
        const initDistinctServiceLines: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.service_line)));
        const initDistinctFunctions: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.function)));
        const initDistinctCareerLevels: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.career_level)));
        const initDistinctResourceTypes: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.resource_type)));

        // Clean: blank out any field whose saved value is no longer valid in the current base pricing version
        const cleanedParticipantsData = cleanUiResourceRequestList(rawParticipantsData, {
          resourceTypes: initDistinctResourceTypes,
          selectRegions: initDistinctRegions,
          serviceLineCapabilities: initDistinctServiceLines,
          functions: initDistinctFunctions,
          selectLevels: initDistinctCareerLevels,
        });

        setParticipantsAndRatesInitialData(cleanedParticipantsData.map((item: any) => {
          const lookUpValues = pricingCalculatorDetailsData.filter((data: any) =>
            data.resource_type === item.resourceType &&
            data.region === item.selectRegion &&
            data.service_line === item.serviceLineCapability &&
            data.career_level === item.selectLevel &&
            data.function === item.function
          )[0];
          const loadedLaborCostHr = lookUpValues?.cost_per_hour ?? item.loadedLaborCostHr;
          const targetClientMargin = lookUpValues?.target_client_margin ? Number((lookUpValues.target_client_margin * 100).toFixed(2)) : item.targetClientMargin;
          const minFTE = lookUpValues?.min_fte_allocation ?? 0;
          return {
            ...item,
            'loadedLaborCostHr': loadedLaborCostHr,
            'targetClientMargin': targetClientMargin,
            'targetPriceHr': Number(((loadedLaborCostHr * 100) / (100 - targetClientMargin)).toFixed(2)),
            'clientMarginProposed': Number((100 - ((100 * loadedLaborCostHr) / (item.proposedPriceHr))).toFixed(2)),
            'varianceTargetMargin': (Number((100 - ((100 * loadedLaborCostHr) / (item.proposedPriceHr))).toFixed(2))) - targetClientMargin,
            'minFTE': minFTE,
          };
        }))

        setResourceFinalAllocationPlanData(dealVersionDetails.resource_allocation_plan.map((item: any, index: number) => ({
          'key': item.key,
          'oldKey': item.key,
          'role': `${dealVersionDetails.participants_rate_data[index].resource_type} - ${dealVersionDetails.participants_rate_data[index].region} - ${dealVersionDetails.participants_rate_data[index].service_line} - ${dealVersionDetails.participants_rate_data[index].career_level}`,
          'allocation': item.allocation,
          'startDate': dayjs(calculateStartDate(dealVersionDetails.project_start_date, dealVersionDetails.duration_in_months, item.start_date, ).replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")),
          'endDate': dayjs(calculateEndDate(dealVersionDetails.project_start_date, dealVersionDetails.duration_in_months, item.end_date).replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")),
          'duration': item.duration,
          'months': item.monthly_wise_allocation,
          'name': item.name,
          'comment': item.comment,
          'startDateWarning': false,
          'endDateWarning': false,
          'minFTE':dealVersionDetails.participants_rate_data[index].minFTE,
        }))
        );


        setDiscountValue(dealVersionDetails.project_discount);
        setcontingencyValue(dealVersionDetails.fixed_fee_contingency);
        setDiscountRationale(dealVersionDetails.discount_rationale);
        setDealPricingComment(dealVersionDetails.deal_economics_summaries.deal_pricing_comment);
        setBelowTargetMarginReason(dealVersionDetails.deal_economics_summaries.below_target_margin_reason);

        setPricingVersion(pricingVersion);
        setPricingContributors(pricingContributors);
        setHubspotDealData(dealDetails);
        setPricingCollaborators(dealVersionDetails.deal_collaborators);
        setPricingCalculatorDetails(pricingCalculatorDetailsData);
        setTargetMarginDD(discountTargetMarginDD.below_target_margin_reasons);
        setDiscountRationaleDD(discountTargetMarginDD.discount_rationale);
        // Extract distinct service_line
        const distinctServiceLines: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.service_line)));

        setDistinctServiceLines([...distinctServiceLines, "Contingency"]);
      } else {
        if (featureList.error_status === 401 || pricingContributors.error_status === 401 || pricingVersion.error_status === 401 || dealVersionDetails.error_status === 401 || pricingCalculatorDetailsData.error_status === 401 || discountTargetMarginDD.error_status === 401) {
          setTokenExpired(true);
        }
        else if (featureList.error_status === 403 || pricingContributors.error_status === 403 || pricingVersion.error_status === 403 || dealVersionDetails.error_status === 403 || pricingCalculatorDetailsData.error_status === 403 || discountTargetMarginDD.error_status === 403) {
          setNoAccess(true);
        }
        setError(featureList.error + ' ' + pricingContributors.error + ' ' + pricingVersion.error + ' ' + dealVersionDetails.error + ' ' + pricingCalculatorDetailsData.error + ' ' + discountTargetMarginDD.error);

      }
      setLoading(false);
    };
    fetchDealDetails();
  } else {
    setError('Deal ID is missing');
    setLoading(false);
  }
}, []);

  useEffect(() => {
    handleResourceAllocationCallback(ResourceFinalAllocationPlanData)
    if (discountValue === 0) {
      setDiscountRationale('')
    }
  }, [discountValue, contingencyValue, nonResourceData, monthlyHours]);

  useEffect(() => {
    if (HubspotDealData && HubspotDealData['Engagement Type'] === 'Fixed Fee') {
      if (!isDealVersionDetailsLoaded)
        setcontingencyValue(20)
    }
  }, [HubspotDealData]);

  useEffect(() => {
    if (monthlySummaryData.length > 0) {
      const dealEconomicsSummariesData: any[] = [{}];
      const dealEconomicsSummariesGrossNetData: any[] = [{}];
      const fieldNames = ["Project Revenue $", "Project Labor Cost $", "Projected Client Margin %", "Target Client Margin %", "Variance to Target", "Blended Hourly Price", "Blended Daily Price"];
      const contingencyAmount = Number((monthlySummaryData[0].total * (contingencyValue / 100)).toFixed(2));
      const discountAmount = Number(((Number(monthlySummaryData[0].total) + Number(contingencyAmount)) * (discountValue / 100)).toFixed(2));
      const costContingencyAmount = Number((monthlySummaryData[3].total * (contingencyValue / 100)).toFixed(2));
      const costDiscountAmount = Number(((Number(monthlySummaryData[3].total) + Number(costContingencyAmount)) * (discountValue / 100)).toFixed(2));
      fieldNames.forEach((fieldName, index) => {
        dealEconomicsSummariesGrossNetData[index] = {};
        //TO-DO: instead of array index use find method to get the particular value
        switch (fieldName) {
          case "Project Revenue $":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = monthlySummaryData[0].total;
            dealEconomicsSummariesGrossNetData[index]['discount'] = Math.round(contingencyAmount - discountAmount);
            dealEconomicsSummariesGrossNetData[index]['net'] = Math.round(monthlySummaryData[0].total + (contingencyAmount - discountAmount));
            break;
          case "Project Labor Cost $":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = monthlySummaryData[3].total;
            dealEconomicsSummariesGrossNetData[index]['discount'] = Math.round(costContingencyAmount);
            dealEconomicsSummariesGrossNetData[index]['net'] = Math.round(monthlySummaryData[3].total + (costContingencyAmount));
            break;
          case "Projected Client Margin %":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = monthlySummaryData[6].total;
            dealEconomicsSummariesGrossNetData[index]['discount'] = '';
            dealEconomicsSummariesGrossNetData[index]['net'] = dealEconomicsSummariesGrossNetData[0]['net'] != 0 ? (((dealEconomicsSummariesGrossNetData[0]['net'] - dealEconomicsSummariesGrossNetData[1]['net']) / dealEconomicsSummariesGrossNetData[0]['net']) * 100).toFixed(1) + '%' : '0%';
            break;

          case "Target Client Margin %":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = monthlySummaryData[7].total;
            dealEconomicsSummariesGrossNetData[index]['discount'] = '';
            dealEconomicsSummariesGrossNetData[index]['net'] = monthlySummaryData[7].total;
            break;
          case "Variance to Target":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = (parseFloat((monthlySummaryData[6].total).replace('%', '')) - parseFloat((monthlySummaryData[7].total).replace('%', ''))).toFixed(1) + '%';
            dealEconomicsSummariesGrossNetData[index]['discount'] = '';
            dealEconomicsSummariesGrossNetData[index]['net'] = (parseFloat(dealEconomicsSummariesGrossNetData[2]['net'].replace('%', '')) - parseFloat((monthlySummaryData[7].total).replace('%', ''))).toFixed(1) + '%';
            break;

          case "Blended Hourly Price":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = monthlySummaryData[2].total == 0 ? 0 : Number((monthlySummaryData[0].total / monthlySummaryData[2].total).toFixed(2));
            dealEconomicsSummariesGrossNetData[index]['discount'] = '';
            dealEconomicsSummariesGrossNetData[index]['net'] = monthlySummaryDataAfterDiscount[2].total.replace(' hr', '') == 0 ? 0 : Number((dealEconomicsSummariesGrossNetData[0]['net'] / (monthlySummaryDataAfterDiscount[2]?.total ? monthlySummaryDataAfterDiscount[2].total.replace(' hr', '') : "0")).toFixed(2));
            break;
          case "Blended Daily Price":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = Number((dealEconomicsSummariesGrossNetData[5]['gross'] * 8).toFixed(2));
            dealEconomicsSummariesGrossNetData[index]['discount'] = '';
            dealEconomicsSummariesGrossNetData[index]['net'] = Number((dealEconomicsSummariesGrossNetData[5]['net'] * 8).toFixed(2));
            break;

        }

      });
      setDealEconomicsGrossNetSummaries(dealEconomicsSummariesGrossNetData)


      dealEconomicsSummariesData[0]["Blended Hourly Price"] = dealEconomicsSummariesGrossNetData[5]['net'];
      dealEconomicsSummariesData[0]["Total Project Price"] = monthlySummaryData[0].total;
      const contingencySummaryValue = dealEconomicsSummariesData[0]["Total Project Price"] * (contingencyValue / 100)
      dealEconomicsSummariesData[0]["Project Contingency Amount"] = Math.round(contingencySummaryValue);
      const discountSummaryValue = ((Number(dealEconomicsSummariesData[0]["Total Project Price"]) + Number(dealEconomicsSummariesData[0]["Project Contingency Amount"])) * (-1 * discountValue / 100))
      dealEconomicsSummariesData[0]["Project Discount Amount"] = Math.round(discountSummaryValue);
      dealEconomicsSummariesData[0]["Net Project Price"] = Math.round(((Number(dealEconomicsSummariesData[0]["Total Project Price"]) + Number(dealEconomicsSummariesData[0]["Project Contingency Amount"])) + discountSummaryValue));
      dealEconomicsSummariesData[0]["Total Project Labor Cost"] = monthlySummaryData[3].total;
      dealEconomicsSummariesData[0]["Projected Client Margin %"] = dealEconomicsSummariesGrossNetData[0]['net'] != 0 ? Number((((dealEconomicsSummariesGrossNetData[0]['net'] - dealEconomicsSummariesGrossNetData[1]['net']) / dealEconomicsSummariesGrossNetData[0]['net']) * 100).toFixed(1)) : 0;
      dealEconomicsSummariesData[0]["Target Client Margin %"] = parseFloat(monthlySummaryData[7].total.replace('%', ''));
      dealEconomicsSummariesData[0]["Variance to Target Margin %"] = Number((dealEconomicsSummariesData[0]["Projected Client Margin %"] - dealEconomicsSummariesData[0]["Target Client Margin %"]).toFixed(1));

      dealEconomicsSummariesData[0]["Projected Client Margin %"] = `${dealEconomicsSummariesData[0]["Projected Client Margin %"]} %`;
      dealEconomicsSummariesData[0]["Target Client Margin %"] = `${dealEconomicsSummariesData[0]["Target Client Margin %"]} %`;
      dealEconomicsSummariesData[0]["Variance to Target Margin %"] = `${dealEconomicsSummariesData[0]["Variance to Target Margin %"]} %`;
      setDealEconomicsSummaries(dealEconomicsSummariesData)
      // Calculate the discount amount based on the discount percentage on the total project price after contingency
      setDiscountAmount(Math.round(((Number(monthlySummaryData[0].total)+Number(monthlySummaryData[0].total)*(contingencyValue/100)) * ((discountValue ? discountValue : 0) / 100))))
    } else {
      setDealEconomicsGrossNetSummaries([])
      setDealEconomicsSummaries([])

    }
  }, [monthlySummaryData]);

  useEffect(() => {
    // Get all keys from ParticipantsAndRatesData
    const participantsKeys = ParticipantsAndRatesData.map(item => item.oldKey);
    // 1. Update existing ResourceAllocationPlanData if the role or other details have changed
    const updatedRecords = ResourceFinalAllocationPlanData.map(resource => {
      const matchingParticipant = ParticipantsAndRatesData.find(participant => participant.oldKey === resource.oldKey);
      if (matchingParticipant) {
        // Update the role or other fields if necessary
        const newRole = `${matchingParticipant.resourceType} - ${matchingParticipant.selectRegion} - ${matchingParticipant.serviceLineCapability} - ${matchingParticipant.selectLevel}`;
        const diff = calculateDaysBetweenDates(oldStartDate.format('YYYY-MM-DD')+"T00:00:00", templateDetails['Expected Start Date']+"T00:00:00");
        const newStartDate = dayjs(calculateStartDate(templateDetails['Expected Start Date']+"T00:00:00", templateDetails['Duration'], addOrSubtractDays(resource.startDate.format('YYYY-MM-DD')+"T00:00:00", diff)))
        const newEndDate = dayjs(calculateEndDate(templateDetails['Expected Start Date']+"T00:00:00", templateDetails['Duration'], addOrSubtractDaysForEndDate(resource.endDate.format('YYYY-MM-DD')+"T00:00:00", diff,templateDetails['Expected Start Date']+"T00:00:00",oldStartDate.format('YYYY-MM-DD')+"T00:00:00",resource.startDate.format('YYYY-MM-DD')+"T00:00:00")))
        // Update the record if the role has changed
        return {
          ...resource,
          role: newRole,
          startDate: newStartDate,
          oldStartDate: resource.startDate,
          endDate: newEndDate,
          oldEndDate: resource.endDate,
          key: matchingParticipant.key,
          minFTE: matchingParticipant.minFTE
        };
      }

      return resource;
    }).filter(resource => participantsKeys.includes(resource.oldKey));  // Remove records not in ParticipantsAndRatesData
    // 2. Find any new keys in ParticipantsAndRatesData that are not in ResourceAllocationPlanData
    const newRecords = ParticipantsAndRatesData.filter(participant =>
      !ResourceFinalAllocationPlanData.some(resource => resource.oldKey === participant.oldKey)
    ).map(participant => ({
      key: participant.key,  // Use the key from ParticipantsAndRatesData
      oldKey: participant.oldKey,
      role: `${participant.resourceType} - ${participant.selectRegion} - ${participant.serviceLineCapability} - ${participant.selectLevel}`,
      allocation: 100,
      startDate: startDate,
      endDate: getProjectEndDate(startDate, duration),
      duration: duration,
      months: {},
      name: '',
      comment: '',
      startDateWarning: false,
      endDateWarning: false,
      minFTE: participant.minFTE
    }));
    // 3. Combine updated records and new records
    const sortedRecords = [...updatedRecords, ...newRecords].sort((a, b) => a.key - b.key);
    setResourceAllocationPlanData(sortedRecords);

  }, [templateDetails]);

  useEffect(() => {
    if (saveNewPricingVersion) {
      savePricingVersionDetails()
    }
    setSaveNewPricingVersion(false)
  }, [saveNewPricingVersion]);

  useEffect(() => {
    if (servicelineTotalRevenue && servicelineTotalRevenue.length > 0) {
      setUpdatedPricingItems(servicelineTotalRevenue.map(item => ({ name: item.service, amount: item.net })))
    }
  }, [servicelineTotalRevenue]);

  useEffect(() => {
    if (ParticipantsAndRatesData.length === 0 && nonResourceData.length === 0 && nonResourceInitialData.length === 0) {
      setDiscountValue(0)
      setDiscountAmount(0)
    }
  }, [ParticipantsAndRatesData, nonResourceData, nonResourceInitialData]);

  useEffect(() => {
      // Get all keys from ParticipantsAndRatesData
      const participantsKeys = ParticipantsAndRatesData.map(item => item.oldKey);
  
      // 1. Update existing ResourceAllocationPlanData if the role or other details have changed
      const updatedRecords = ResourceFinalAllocationPlanData.map(resource => {
        const matchingParticipant = ParticipantsAndRatesData.find(participant => participant.oldKey === resource.oldKey);
  
        if (matchingParticipant) {
          // Update the role or other fields if necessary
          const newRole = `${matchingParticipant.resourceType} - ${matchingParticipant.selectRegion} - ${matchingParticipant.serviceLineCapability} - ${matchingParticipant.selectLevel}`;
          if (resource.role !== newRole) {
            // Update the record if the role has changed
            return {
              ...resource,
              role: newRole,
              key: matchingParticipant.key,
              minFTE: matchingParticipant.minFTE
            };
          }
          return {...resource, key: matchingParticipant.key, minFTE: matchingParticipant.minFTE };
        }
  
        return resource;
      }).filter(resource => participantsKeys.includes(resource.oldKey));  // Remove records not in ParticipantsAndRatesData
      // 2. Find any new keys in ParticipantsAndRatesData that are not in ResourceAllocationPlanData
      const newRecords = ParticipantsAndRatesData.filter(participant =>
        !ResourceFinalAllocationPlanData.some(resource => resource.oldKey === participant.oldKey)
      ).map(participant => ({
        key: participant.key,  // Use the key from ParticipantsAndRatesData
        oldKey: participant.oldKey,
        role: `${participant.resourceType} - ${participant.selectRegion} - ${participant.serviceLineCapability} - ${participant.selectLevel}`,
        allocation: 100,
        startDate: startDate,
        endDate: getProjectEndDate(startDate, duration),
        duration: duration,
        months: {},
        name: '',
        comment: '',
        startDateWarning: false,
        endDateWarning: false,
        minFTE: participant.minFTE
      }));
      // 3. Combine updated records and new records
      const sortedRecords = [...updatedRecords, ...newRecords].sort((a, b) => a.key - b.key);
      setResourceAllocationPlanData(sortedRecords);
  
    }, [ParticipantsAndRatesData]);
    
  return (
    <>
      {!viewOnly && <FloatButton
        shape="square"
        type="primary"
        style={{ insetInlineEnd: 20, insetBlockEnd: 20, border: "1px solid rgb(255, 255, 255)", width: "120px" }}
        description={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SaveOutlined style={{ fontSize: '22px', marginRight: '8px' }} />
            <span style={{ fontSize: '16px' }}>Save</span>
          </div>
        }
        tooltip={isDealLocked ? <div>Unlock to Update the Current Pricing Version</div> : <div>Click to Save Pricing Template</div>}
        // icon={<SaveOutlined />}
        badge={{ dot: true, color: `${(isDealLocked || !enabledFeatureList.includes('FE_CREATE_PRICING_TEMPLATE') || errorArray.length > 0) ? 'grey' : 'green'}` }}
        onClick={() => {
          if (isDealLocked) {
            message.error("Unlock deal to update")
            return
          }
          if (!enabledFeatureList.includes('FE_CREATE_PRICING_TEMPLATE')) {
            message.error("Unauthorised to update the deal")
            return
          }
          if (errorArray.length > 0) {
            message.error("Resolve the Error to update the deal")
            return
          }
          setVersionNameInputVisible(false);
          checkValidations();
          // setNewVersionNameModalVisible(true);
        }}
      />}

      {/* Main components */}
      {noAccess ? <NoAccessPopup openPopup={true} popupMessage={'You do not have access to view pricing for this deal'}/>:
      tokenExpired ? <LogoutPopUp openPopup={tokenExpired} /> :
        <div>
          {error && <p className='text-danger'>Errors:<br></br> {
            error.includes(",") ? (
              error.split(",").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))) : <>{error}</>}</p>}
          {loading ? <LoadingOutlined style={{ fontSize: "40px", color: "cornflowerblue" }} /> :
            <>
              {savePricingLoader &&
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent white
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999, // Ensure the loader is on top
                  }}
                >
                  <LoadingOutlined style={{ fontSize: "40px", color: "cornflowerblue" }} />
                </div>}

              <Modal
                title={<span className='text-danger'>HubSpot Data Issue!</span>}
                open={isRedirectToHome}
                onOk={() => navigate('/home')} // Redirect to home page
                onCancel={() => navigate('/home')}
                width={'50%'}
              >
                <p><b>{fatalError}</b> , Please edit and save the valid values in HubSpot!</p>
                <p className='mt-3'></p>
                <p className='mt-3'>You will be redirected to home page!</p>
              </Modal>

              <Modal
                title={<span className='text-danger'>HubSpot Deal Details Changed!</span>}
                open={isHubspotFieldsChanged}
                onOk={() => setIsHubspotFieldsChanged(false)}
                onCancel={() => setIsHubspotFieldsChanged(false)}
                width={'50%'}
              >
                <p>The following HubSpot deal details have changed after pricing version was created:</p>
                <strong>Fields Changed:</strong>
                <HubspotFieldsChangeTable dataSource={hubspotFieldsChangedArray} />
                <p className='mt-3'>Please review pricing and make updates accordingly.</p>
              </Modal>

              <Modal
                title={<span>Save Pricing Template</span>}
                open={newVersionNameModalVisible}
                onOk={() => {
                  if (!error) {
                    setNewVersionNameModalVisible(false)
                    setSaveNewPricingVersion(true)
                    setReloadNavigation(true)
                  } else {
                    setNewVersionNameModalVisible(false)
                  }
                }}
                onCancel={() => {
                  setErrorMessage('');
                  setNewVersionNameModalVisible(false)
                }}
                width={'70%'}
              >
                {error && <p className='text-danger'>Error: {error}</p>}

                {!error &&
                  <div className='pt-2 ps-2' style={{ border: "1px solid #80808017" }}>
                    <p>Do you want to update the Pricing Template?</p>
                    <br></br>
                    <b>Note: Project ODE Client Margin ($/%) reflects only Americas Non-IS and Non-Data Line Items.</b>
                    <br></br>
                    {/* {sendEmail && <ResourceAllocationPlan dataSource={ResourceFinalAllocationPlanData} onChange={handleResourceAllocationCallback} monthColumns={monthColumns} duration={duration} startDate={startDate} endDate={endDate} isEditable={false} />} */}

                    {errorMessage && (
                      <div style={{ color: 'red', marginTop: '16px' }}>
                        {errorMessage}
                      </div>
                    )}
                  </div>
                }
              </Modal>
              <Modal
                title={<span><CheckCircleOutlined style={{ color: 'green' }} /> Success</span>}
                open={isSuccessModalVisible}
                onOk={() => {
                  setIsSuccessModalVisible(false)
                  if (reloadNavigation) {
                    navigate(`/pricing-template?templateId=${dealId}&templateName=${encodeURIComponent(versionName)}`);  // Navigate to /edit-pricing page
                    setReloadNavigation(false)
                    window.location.reload();
                  }
                }}
                onCancel={() => {
                  setIsSuccessModalVisible(false)
                  if (reloadNavigation) {
                    navigate(`/pricing-template?templateId=${dealId}&templateName=${encodeURIComponent(versionName)}`);  // Navigate to /edit-pricing page
                    setReloadNavigation(false)
                    window.location.reload();
                  }
                }}
              >
                {lockOde ? <p>Pricing version saved and locked as ODE.</p> : sendHubspotLineItems || showHubspotLineItemsUpdatedMessage ? <p>Line Items updated successfully to HubSpot.</p> : <p>Pricing version saved successfully.</p>}
              </Modal>
              {isLinkedTemplate && <Alert type="info" showIcon style={{ marginBottom: 16 }}
                message="This template is linked to a deal and is read-only."
                description="Make deal-specific changes in the deal. To change this template's pricing, clone it as a new template." />}
              {canCopyTemplate && <div style={{ marginBottom: 16 }}>
                <CopyPricingTemplateButton templateId={String(dealId)} templateName={HubspotDealData['Template Name']}
                  onCopied={template => window.location.assign(`/pricing-template?templateId=${template.template_id}&templateName=${encodeURIComponent(template.template_name)}`)}
                  onTokenExpired={() => setTokenExpired(true)} />
              </div>}
              <PricingTemplateDetails dataSrc={HubspotDealData} onEdit={handleTemplateDetailsChange} pricingContributors={PricingContributors} templateId={dealId} showHubspotLink={true} pricingVersion={PricingVersion} onBasePriceVersionChange={handleBasePricingVersionChange} onUseOldWorkhoursChange={handleUseOldWorkhoursChange} readOnly={viewOnly}/>
              <Spin spinning={basePricingLoader} tip="Updating pricing rates...">
              <ParticipantsAndRates dataSource={ParticipantsAndRatesInitialData} onChange={handleParticipantsAndRatesCallback} pricingCalculatorDetailsData={pricingCalculatorDetails} viewOnly={viewOnly}
                onCopyResources={!viewOnly && !basePricingLoader ? () => setCopyResourcesOpen('deal') : undefined}
                onSearchEmployees={!viewOnly && !basePricingLoader ? () => setCopyResourcesOpen('employee') : undefined} />
              </Spin>
              {!viewOnly && copyResourcesOpen && <ResourceImportModal start={startDate} end={endDate} duration={duration} rates={pricingCalculatorDetails ?? []}
                basePriceVersionId={versionId} pricingVersions={PricingVersion}
                firstKey={Math.max(0, ...ParticipantsAndRatesData.map(r => r.oldKey)) + 1}
                onClose={() => setCopyResourcesOpen(false)} onApply={({ participants, allocations }, replace) => {
                  const newParticipants = [...(replace ? [] : ParticipantsAndRatesData), ...participants].map((r, i) => ({ ...r, key: i + 1 }));
                  const newAllocations = [...(replace ? [] : ResourceFinalAllocationPlanData), ...allocations].map((r, i) => ({ ...r, key: i + 1 }));
                  setResourceFinalAllocationPlanData(newAllocations);
                  setResourceAllocationPlanData(newAllocations);
                  setParticipantsAndRatesInitialData(newParticipants);
                  setParticipantsAndRatesData(newParticipants);
                  message.success('Resources added. Review the dates and allocations, then save the template.');
                }} />}
              <div id="resource-allocation-section">
                <ResourceAllocationPlan dataSource={ResourceAllocationPlanData} onChange={handleResourceAllocationCallback} monthColumns={monthColumns} duration={duration} startDate={startDate} endDate={endDate} viewOnly={viewOnly} additionalResourcingInfo={additionalResourcingInfo} setAdditionalResourcingInfo={setAdditionalResourcingInfo} setMinFTEWarning={setminFTEWarning} />
              </div>
              <NonResourceCosts dataSource={nonResourceInitialData} onChange={setNonResourceData} nonResourcePricingDetailsData={nonResourcePricingDetails} startDate={startDate} endDate={endDate} viewOnly={viewOnly} />
              <ProjectRevenue title="Deal Revenue and Cost Details" dataSource={revenueData} monthColumns={monthColumns} duration={duration} startDate={startDate} />
              <SummaryTable title="Total Monthly Summary Before Adjustments" dataSource={monthlySummaryData} monthColumns={monthColumns} />

              {/* Fixed-Fee Project Contingency Section */}
              {(HubspotDealData && HubspotDealData['Engagement Type'] === 'Fixed Fee') ? (
                <Card title="Fixed-Fee Project Contingency" style={{ marginBottom: '16px' }}>
                  <div className='mb-4'>
                    <Badge status="default" style={{ marginRight: "5px" }} text="Contingency:" />
                    <InputNumber
                      min={0}
                      max={100}
                      value={contingencyValue}
                      formatter={(value) => `${value} %`}
                      onChange={(value) => setcontingencyValue(value ? value : 0)}
                      style={{ width: 100, borderColor: 'blue', marginRight: '10px' }}
                      className="bold-input"
                      disabled={viewOnly}
                    />
                    <Tooltip title={<span dangerouslySetInnerHTML={{ __html: getTooltip("Contingency") || '' }} />}>
                      <InfoCircleOutlined style={{ marginLeft: "10px", marginTop: "2px", color: "#4096FF" }} />
                    </Tooltip>
                  </div>
                </Card>
              ) : null}

              {/* Adjustments Section */}
              <Card title={<>Adjustments<Tooltip title={<span dangerouslySetInnerHTML={{ __html: getTooltip("Discount and Contingency") || '' }} />}><InfoCircleOutlined style={{ marginLeft: "10px", marginTop: "2px", color: "#4096FF" }} /></Tooltip></>} style={{ marginBottom: '16px' }}>
                {/* Gross Revenue section after contingency*/}
                <div className='mb-4'>
                  <Badge status="default" style={{ marginRight: "5px" }} text="Gross Revenue:" />
                  <InputNumber
                    prefix={'$'}
                    value={dealEconomicsSummaries.length > 0 ? Math.round(dealEconomicsSummaries[0]["Total Project Price"] + dealEconomicsSummaries[0]["Total Project Price"]*contingencyValue/100) : 0}
                    style={{ width: 150, borderColor: 'blue' }}
                    className="bold-input"
                    disabled={true}
                  />
                  </div>

                {/* Discount section with percentage and amount in one line */}
                <div className='mb-4' style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                <Badge status="default" style={{ marginRight: "5px" }} text="Discount/Round Up (%):" />
                {/* Discount percentage input field with validation (-100% to 100%) */}
                <InputNumber
                  min={-100}
                  max={100}
                  value={discountValue}
                  suffix="%"
                  onChange={(value) => {
                    changeDiscountValue(value, setDiscountValue, setDiscountAmount, dealEconomicsSummaries, contingencyValue)
                  }}
                      style={{ width: 100, borderColor: 'blue' }}
                  className="bold-input"
                  disabled={viewOnly || dealEconomicsSummaries.length < 1}
                />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                {/* Label for discount amount field */}
                <Badge status="default" style={{ marginRight: "5px" }} text="Discount/Round Up ($):" />
                {/* Discount amount input field in dollars */}
                <InputNumber
                  prefix={'$'}
                  value={discountAmount}
                  onChange={(value) => {
                    changeDiscountAmount(value, setDiscountValue, setDiscountAmount, dealEconomicsSummaries, contingencyValue)
                  }}
                      style={{ width: 100, borderColor: 'blue' }}
                  className="bold-input"
                  disabled={viewOnly || dealEconomicsSummaries.length < 1}
                />
                  </div>
                {/* Rationale dropdown - only shown when discount is applied */}
                  {discountValue !== 0 && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Badge status="error" style={{ marginRight: "5px" }} text="Rationale:" />
                      <Select
                        style={{ width: '15rem' }}
                  disabled={viewOnly}
                  onChange={(value) => setDiscountRationale(value)}
                  status={discountValue !== 0 && discountRationale == '' ? "error" : ""}
                  value={discountRationale}>
                      {/* Different options for positive discount vs round up */}
                  {discountValue > 0 ? (
                    <>
                      <option value={''}>Select Rationale</option>
                      {(discountRationaleDD && discountRationaleDD.length > 0) &&
                            discountRationaleDD.filter((filterItem: any) => !filterItem.reason.includes('Roundup')).map((item: any) => <option key={item.reason} value={item.reason}>{item.reason}</option>)
                      }
                    </>
                  ) : <>
                  <option value={''}>Select Rationale</option>
                  {(discountRationaleDD && discountRationaleDD.length > 0) &&
                    discountRationaleDD.filter((filterItem:any) => filterItem.reason.includes('Roundup')).map((item: any) => <option key={item.reason} value={item.reason}>{item.reason}</option>)
                  }
                </>}
                </Select>
                    </div>
                  )}
                </div>
                <p className='mt-2'><i>Enter a negative discount number to round up</i></p>

                {/* Net Revenue section */}
                <div className='mb-4'>
                  <Badge status="default" style={{ marginRight: "5px" }} text="Net Revenue:" />
                  <InputNumber
                    min={0}
                    max={dealEconomicsSummaries.length > 0 ? Math.round(dealEconomicsSummaries[0]["Total Project Price"] + dealEconomicsSummaries[0]["Total Project Price"]*contingencyValue/100)*2 : 0} // double of gross revenue
                    prefix={'$'}
                    value={dealEconomicsSummaries.length > 0 ? dealEconomicsSummaries[0]["Net Project Price"] : 0}
                    onChange={(value) => {
                      changeTotalAmount(value, setDiscountValue, setDiscountAmount, dealEconomicsSummaries, contingencyValue)
                    }}
                    style={{ width: 150, borderColor: 'blue' }}
                    className="bold-input"
                    disabled={viewOnly || dealEconomicsSummaries.length < 1}
                  />
                  <Tooltip title={<span dangerouslySetInnerHTML={{ __html: getTooltip("Net Revenue") || '' }} />}>
                    <InfoCircleOutlined style={{ marginLeft: "10px", marginTop: "2px", color: "#4096FF" }} />
                  </Tooltip>
                </div>

              </Card>
              <SummaryTable title="Total Monthly Summary After Adjustments" dataSource={monthlySummaryDataAfterDiscount} monthColumns={monthColumns} />
              <RevenueSummary dataSrc={servicelineTotalRevenue} dealId={dealId} setSaveNewPricingVersion={setSaveNewPricingVersion} setReloadNavigation={setReloadNavigation} isDealLocked={isDealLocked} enabledFeatureList={enabledFeatureList} distinctServiceLines={distinctServiceLines} setSendHubspotLineItems={setShowHubspotLineItemsUpdatedMessage} />
              <DealEconomicsSummariesDetails dataSource={dealEconomicsSummaries} grossNetDataSource={dealEconomicsGrossNetSummaries} totalBillableHours={monthlySummaryDataAfterDiscount[2]?.total ? monthlySummaryDataAfterDiscount[2].total.replace(' hr', '') : "0"} onChange={handledealEconomicsFinalData} targetMarginDD={targetMarginDD ?? []} initialDealPricingComment={dealPricingComment ?? ''} initialbelowTargetMarginReason={belowTargetMarginReason ?? ''} span={24} viewOnly={viewOnly} />
            </>
          }
        </div>
      }
    </>
  );
};

export default EditPricingDetails;
